import * as React from "react";
import LinkComp from "../LinkComp";
import Tabs from "../Tabs";

/**
 * The investors, agents and vendors attached to this firm.
 *
 * Deleting a firm leaves them pointing at one that is no longer there, so the
 * screen says who they are before anyone reaches for Delete. A firm nobody is
 * attached to says so in a line of text rather than showing empty tabs.
 */
const PeopleTable = ({rows, path}) => (
    <div className="Firm-people_scroll">
        <table className="Firm-people_table">
            <thead>
                <tr>
                    <th>NAME</th>
                    <th>EMAIL</th>
                    <th>PHONE</th>
                </tr>
            </thead>
            <tbody>
                {rows.map((person) => (
                    <tr key={person.ARCIMEDES_ROW_ID}>
                        <td>
                            <LinkComp to={`${arc.path.base}${path}/${person.ARCIMEDES_ROW_ID}`}>
                                {person.NAME || "(no name)"}
                            </LinkComp>
                        </td>
                        <td>{person.EMAIL || "-"}</td>
                        <td>{person.PHONE || "-"}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    </div>
);

const FirmPeople = ({people, isBusy, error}) => {
    const rows = people || [];
    const investors = rows.filter((person) => person.TYPE === "Investor");
    const agents = rows.filter((person) => person.TYPE === "Agent");
    const vendors = rows.filter((person) => person.TYPE === "Vendor");

    const note = (text) => (
        <div className="Firm-people">
            <div className="Firm-people_note">{text}</div>
        </div>
    );

    if (isBusy) return note("Loading attached people...");

    if (error) return note(error);

    if (rows.length === 0) {
        return note("No investors, agents or vendors are attached to this firm.");
    }

    const count = (n, word) => `${n} ${word}${n === 1 ? "" : "s"}`;
    const parts = [
        investors.length && count(investors.length, "investor"),
        agents.length && count(agents.length, "agent"),
        vendors.length && count(vendors.length, "vendor"),
    ].filter(Boolean);
    const summaryText = parts.length > 1
        ? `${parts.slice(0, -1).join(", ")} and ${parts[parts.length - 1]}`
        : parts[0];

    const tabsData = [];

    if (investors.length) {
        tabsData.push({
            name: `INVESTORS (${investors.length})`,
            className: "",
            renderedComponent: <PeopleTable rows={investors} path="investor"/>,
        });
    }

    if (agents.length) {
        tabsData.push({
            name: `AGENTS (${agents.length})`,
            className: "",
            renderedComponent: <PeopleTable rows={agents} path="agent"/>,
        });
    }

    if (vendors.length) {
        tabsData.push({
            name: `VENDORS (${vendors.length})`,
            className: "",
            renderedComponent: <PeopleTable rows={vendors} path="vendor"/>,
        });
    }

    return (
        <div className="Firm-people">
            <div className="Firm-people_note">
                {summaryText} would be left without a firm if this one is deleted.
            </div>
            <Tabs tabsData={tabsData}/>
        </div>
    );
};

export default FirmPeople;
